import React, { useRef } from "react";
import ReactQuill from "react-quill";
import { ErrorMessage, useField, useFormikContext } from "formik";
import { Typography } from "@mui/material";

import "react-quill/dist/quill.snow.css";
import "quill-emoji/dist/quill-emoji.css";
import "quill-emoji/dist/quill-emoji.js";

import FormikLabel from "./FormikLabel";
import { ErrorStyle } from "./ErrorStyle";

const modules = {
  toolbar: [
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image"],
    ["emoji"],
  ],
  "emoji-toolbar": true,
  "emoji-shortname": true,
};

const formats = [
  "bold",
  "italic",
  "underline",
  "list",
  "bullet",
  // "link",
  // "image",
  "emoji",
];

const FormikReactQuillEditor = ({
  name,
  label,
  onChange = () => {},
  disabled = false,
  readOnly = false,
  required = false,
}) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);
  const editorRef = useRef();

  const handleChange = (value) => {
    setFieldValue(name, value);
    onChange(value);
  };

  return (
    <div style={{ marginBottom: "1rem" }}>
      {label && <FormikLabel text={label} required={required} />}
      <ReactQuill
        ref={editorRef}
        value={field.value || ""}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        readOnly={disabled || readOnly}
        theme="snow"
        style={{
          backgroundColor: disabled || readOnly ? "#f5f5f5" : "white",
          borderRadius: "6px",
        }}
      />
      {/* Minimum 3 lines (adjust height here) */}
      <style>{`
        .ql-container {
          min-height: 120px;
        }
      `}</style>
      <div style={ErrorStyle}>
        <ErrorMessage name={name} />
      </div>
    </div>
  );
};

export default FormikReactQuillEditor;
